/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshCardTabSchemeRequest} from '@cash-web/protos/squareup/cash/postcard/app/RefreshCardTabScheme.pb'
import {RefreshCardTabSchemeResponse} from '@cash-web/protos/squareup/cash/postcard/app/RefreshCardTabScheme.pb'


export const refreshCardTabScheme = (request: RefreshCardTabSchemeRequest, options?: CashRequestOptions) => post<RefreshCardTabSchemeRequest, RefreshCardTabSchemeResponse>("/cash-app/postcard/refresh-card-tab", request, {...options, rejectOnError: true })